import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import { UserFields } from '../../Endpoint/UserFields';

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const { addSubField, group } = this.props;

		const defaultFields = [];

		UserFields.forEach((el) => {
			if ( el.value === 'ID' ) {
				defaultFields.push( getFieldFactory().getNewDefaultFieldGroup( 'ID', 'User ID in', 'input', '' ) );
			} else if ( el.value === 'roles' ) {
				defaultFields.push( getFieldFactory().getRolesFieldGroup( 'checkboxes' ) );
			} else {
				defaultFields.push( getFieldFactory().getNewDefaultFieldGroup( el.value, el.name, 'input', '' ) );
			}
		});

		defaultFields.push( getFieldFactory().getRolesFieldGroup( 'checkboxes', 'role__in', 'Roles in' ) );
		defaultFields.push( getFieldFactory().getNewDefaultFieldGroup( 'blog_id', 'Blog ID', 'input', '' ) );
		defaultFields.push( getFieldFactory().getYesNoFieldGroup( 'has_published_posts', 'Has Published Posts' ) );
		defaultFields.push( getFieldFactory().getNewDefaultFieldGroup( 'exclude', 'User ID not in', 'input', '' ) );

		return (
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (

						<React.Fragment>
							<h3>Default Fields ({endpoint[action][currentItem].defaultFields.length})</h3>

							<p>Use this section for adding a filter for one or more default user fields. You can set a fixed value for it or use an already defined parameter.</p>

							<ParametersNotice parameters={endpoint.parameters}/>

							<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
								{defaultFields.sort((a, b) => (a.label > b.label) ? 1 : -1).map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
							</select>

							<button
							onClick={() => addSubField(endpointId, defaultFields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
							>
							Add a filter
							</button>

							<FieldGroups group={group} />

						</React.Fragment>
					)}

				</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(DefaultFieldsFilter);
